export enum OnlyFor {
    Past, Future
}